import { FC, useEffect, useState } from "react";
import Input from "shared/Input/Input";
import Select from "shared/Select/Select";
import CommonLayout from "./CommonLayout";
import FormItem from "./FormItem";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentExperience, setExperience } from "application/features/experience/experienceSlice";
import Checkbox from "shared/Checkbox/Checkbox";
import InfoTooltip from "components/Quasi/InfoTooltip/InfoTooltip";

export interface PageAddListing8Props { }

const PageAddExperience3: FC<PageAddListing8Props> = () => {

  const [availability, setAvailability] = useState<any>({
    week: false,
    weekend: false,
    weekdays: false,
  });
  const [yearlyAvailability, setYearlyAvailability] = useState<boolean>(true);
  const [onlyInPackage, setOnlyInPackage] = useState<boolean>(false);

  const experience = useSelector(selectCurrentExperience)
  const dispatch = useDispatch()

  const handleUpdateExperience = async (field: string, value: any) => {
    try {
      dispatch(setExperience(
        { ...experience, [field]: value }
      ))
      if (field === "yearly_availability") {
        setYearlyAvailability(value);
        if (value) {
          dispatch(setExperience({ ...experience, available_from_date: null, available_to_date: null }));
        } else {
          dispatch(setExperience({ ...experience, available_from_date: "", available_to_date: "" }));
        }
      } else if (field === "only_in_package") {
        setOnlyInPackage(value);
      }
    }
    catch (e) {
      console.log(e)
    }
  };

  const handleUpdateAvailability = (name: string, e: any) => {
    const arr = { ...availability, [name]: e }
    // flag to false all the other keys
    Object.keys(arr).forEach((key) => {
      if (key !== name) {
        arr[key] = false
      }
    })
    setAvailability(arr)
  }

  const handleUpdateYearlyAvailability = (e: boolean) => {
    setYearlyAvailability(e);
  };


  // This is for weekly availability
  useEffect(() => {
    const key = Object.keys(availability).find(key => availability[key] === true)
    handleUpdateExperience("availability", key)
  }, [availability]);

  useEffect(() => {
    console.log('Initial load of experience:', experience);
    const defaultAvailability = {
      only_in_package: false,
      availability: "week",
      yearly_availability: true,
      available_from_date: null,
      available_to_date: null
    };
    // Dispatch the experience with default values
    const updatedExperience = {
      ...experience,
      only_in_package: experience.only_in_package || defaultAvailability.only_in_package,
      availability: experience.availability || defaultAvailability.availability,
      yearly_availability: experience.yearly_availability || defaultAvailability.yearly_availability,
      available_from_date: experience.available_from_date || defaultAvailability.available_from_date,
      available_to_date: experience.available_to_date || defaultAvailability.available_to_date
    };

    setAvailability({
      week: updatedExperience.availability === "week",
      weekend: updatedExperience.availability === "weekend",
      weekdays: updatedExperience.availability === "weekdays",
    });
    setYearlyAvailability(updatedExperience.yearly_availability);
    setOnlyInPackage(updatedExperience.only_in_package);
    dispatch(setExperience({ ...updatedExperience }));
  }, []);


  const canGoNextFunction = (): boolean => {
    console.log('Checking if can go to next step');
    console.log('Current experience state:', experience);
    const nonEmptyFields: boolean = experience.price?.length > 0 &&
      experience.availability?.length > 0 &&
      experience.max_guests > 0 &&
      experience.minutes_duration > 0;
    console.log('Non empty fields:', nonEmptyFields);
    if (yearlyAvailability) {
      console.log('Yearly availability is enabled');
      const condition = nonEmptyFields &&
        experience.available_from_date === null &&
        experience.available_to_date === null;
      console.log('Condition for yearly availability:', condition);
      return condition;
    } else if (!yearlyAvailability && experience.available_from_date && experience.available_to_date) {
      const condition = nonEmptyFields &&
        experience.available_from_date.length > 0 &&
        experience.available_to_date.length > 0;
      console.log('Condition for non-yearly availability:', condition);
      return condition;
    } else {
      return false;
    }
  }

  return (
    <CommonLayout
      index="03"
      backtHref="/host/new-experience/add-listing-2"
      nextHref="/host/new-experience/add-listing-4"
      canGoNext={canGoNextFunction()}
    >
      <>
        <div>
          <h2 className="text-2xl font-semibold inline-flex items-center">
            Prezzo e disponibilità
            <InfoTooltip className="ml-2" i18nKey="translation:tooltips.experience_upload.prezzo_e_disponibilita" />
          </h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Scegli il prezzo per ogni ospite che partecipa all'esperienza e quando è disponibile la tua esperienza
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* FORM */}
        <div className="space-y-8">
          {/* ITEM */}
          <FormItem label="Valuta">
            <Select>
              <option value="EUR">EUR</option>
            </Select>
          </FormItem>
          <FormItem label="Prezzo per persona">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span className="text-gray-500">€</span>
              </div>
              <Input
                onChange={(e) => handleUpdateExperience("price", e.target.value)}
                className="!pl-8 !pr-10"
                placeholder="0.00"
                type="number"
                value={experience.price || ""}
              />
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <span className="text-gray-500">EUR</span>
              </div>
            </div>
          </FormItem>
          <FormItem label="Posti disponibili">
            <Input
              placeholder="Inserisci i posti disponibili per ogni slot"
              type="number"
              onChange={(e) => handleUpdateExperience("max_guests", e.target.value)}
              value={experience.max_guests || ""}
              min={1}
            />
          </FormItem>

          <FormItem label="Possibilità di prenotazione">
            <Checkbox
              isChecked={onlyInPackage}
              onChange={(e) => { setOnlyInPackage(e); handleUpdateExperience("only_in_package", e); }}
              className="!pl-8 !pr-10 mt-2"
              label="Prenotabile solo in pacchetto"
              name="only_in_package"
            />
          </FormItem>

          <FormItem label="Date di disponibilità">
            <Checkbox
              isChecked={yearlyAvailability}
              onChange={(e) => handleUpdateYearlyAvailability(e)}
              className="!pl-8 !pr-10 mt-2"
              label="Tutto l'anno"
              name="year"
            />
          </FormItem>
          {
            !yearlyAvailability && (
              <FormItem label="Date di inizio disponibilità">
                <Input
                  type="date"
                  onChange={(e) => handleUpdateExperience("available_from_date", e.target.value)}
                  placeholder="DD/MM/YYYY"
                  value={experience.available_from_date || ""}
                />
              </FormItem>
            )
          }
          {
            !yearlyAvailability && (
              <FormItem label="Date di fine disponibilità">
                <Input
                  type="date"
                  onChange={(e) => handleUpdateExperience("available_to_date", e.target.value)}
                  placeholder="DD/MM/YYYY"
                  value={experience.available_to_date || ""}
                />
              </FormItem>
            )
          }
          <FormItem label="Disponibilità settimanale">
            <Checkbox
              isChecked={availability.week}
              onChange={(e) => handleUpdateAvailability("week", e)}
              className="!pl-8 !pr-10 mt-2"
              label="Tutta la settimana"
              name="week"
            />
            <Checkbox
              isChecked={availability.weekend}
              onChange={(e) => handleUpdateAvailability("weekend", e)}
              className="!pl-8 !pr-10 mt-2"
              label="Fine settimana"
              name="weekend" />
            <Checkbox
              isChecked={availability.weekdays}
              onChange={(e) => handleUpdateAvailability("weekdays", e)}
              className="!pl-8 !pr-10 mt-2"
              label="Solo in settimana"
              name="weekdays"
            />
          </FormItem>
          <FormItem label="Disponibile dalle">
            <Select
              onChange={(e) => handleUpdateExperience("available_from", e.target.value)}
              value={experience.available_from || ""}
            >
              <option defaultChecked value={""}>Seleziona</option>
              {
                Array.from(Array(24).keys()).map((item: any, index: Number) => (
                  <option key={item} value={item}>{item}:00</option>
                ))
              }
            </Select>
          </FormItem>
          {
            experience.available_from && (
              <FormItem label="Disponibile fino alle">
                <Select
                  onChange={(e) => handleUpdateExperience("available_to", e.target.value)}
                  value={experience.available_to || ""}
                >
                  <option defaultChecked value={""}>Seleziona</option>
                  {
                    Array.from(Array(25).keys()).slice(Number(experience.available_from) + 1).map((item: any, index: Number) => (
                      <option key={item} value={item}>{item}:00</option>
                    ))
                  }
                </Select>
              </FormItem>
            )
          }
          <FormItem label="Durata (in minuti)">
            <Input
              placeholder="Inserisci la durata dell'esperienza in minuti"
              type="number"
              onChange={(e) => handleUpdateExperience("minutes_duration", e.target.value)}
              value={experience.minutes_duration || ""}
              min={1}
            />
          </FormItem>

        </div>
      </>
    </CommonLayout>
  );
};

export default PageAddExperience3;
